import { useLocalSearchParams } from 'expo-router';

import { HandoffSmsCompose } from '@/components/pages/handoff';
import { parseHandoffIdParam } from '@/models/handoffRouteParams';

const HandoffSmsComposeRoute = () => {
  const { id } = useLocalSearchParams<{ id: string }>();
  const handoffId = parseHandoffIdParam(id);

  return handoffId ? <HandoffSmsCompose id={handoffId} /> : null;
};

export default HandoffSmsComposeRoute;
